<template>
  <v-card class="elevation-0" color="grey lighten-5">
    <v-card-title class="pb-1">
      <span class="title">Details</span>
    </v-card-title>
    <v-card-text>
      <v-layout>
        <v-flex xs6>
          <v-list two-line subheader dense class="grey lighten-5">
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>Price</v-list-tile-title>
                <v-list-tile-sub-title>{{ selectedOffer.price }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>Format</v-list-tile-title>
                <v-list-tile-sub-title>{{ selectedOffer.offerFormat }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>Type</v-list-tile-title>
                <v-list-tile-sub-title>{{ selectedOffer.offerType }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>Target Entity</v-list-tile-title>
                <v-list-tile-sub-title>{{ selectedOffer.targetEntity }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-flex>
        <v-flex xs6>
          <v-list two-line subheader dense class="grey lighten-5">
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>Provider</v-list-tile-title>
                <v-list-tile-sub-title>{{ selectedOffer.providerName }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>Affiliate</v-list-tile-title>
                <v-list-tile-sub-title>{{ selectedOffer.affiliate }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>Tags</v-list-tile-title>
                <v-list-tile-sub-title>{{ selectedOffer.offerTags | arrayToString }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "OfferDetails",
  props: ["selectedOffer"],
  data() {
    return {}
  },
  filters: {
    /**
     * arrayToString - convert array of strings to a 'comma' delimited string
     *
     * @param  {array} value array of strings
     * @return {string}       'comma' delimited string
     */
    arrayToString(value) {
      if (value) {
        return value.join(",")
      } else {
        return ""
      }
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/PreIngest/Offers/OfferDetails.vue